import { render, staticRenderFns } from "./client-details.vue?vue&type=template&id=ef1e0770&scoped=true&"
import script from "./client-details.vue?vue&type=script&lang=js&"
export * from "./client-details.vue?vue&type=script&lang=js&"
import style0 from "./client-details.vue?vue&type=style&index=0&id=ef1e0770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1e0770",
  null
  
)

export default component.exports